export interface PostOrder {
	id: string;
	order: number;
}
